import api from './api';

export interface Benutzer {
  benutzerID: number;
  benutzername: string;
  email: string;
  vorname?: string;
  nachname?: string;
  abteilung?: string;
  status: string;
  rolle?: string; // For project assignments
}

export const benutzerService = {
  // Get all users
  async getAll(): Promise<Benutzer[]> {
    try {
      const response = await api.get<Benutzer[]>('/benutzer');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der Benutzer:', error);
      return [];
    }
  },

  // Get users assigned to a project
  async getByProject(projectId: number): Promise<Benutzer[]> {
    try {
      const response = await api.get<Benutzer[]>(`/projects/${projectId}/users`);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der zugeordneten Benutzer:', error);
      return [];
    }
  },
};
